export class CsdlNavigationPropertyBinding {
    constructor(
        public path: string,
        public target: string,
    ) { }
}
